import React from 'react';
import style from './style.scss';

const Title = ({ children, ...rest }) =>
  <div className={style.title} {...rest}>
    <div className={style.text}>
      {children}
    </div>
    <div className={style.edge} />
  </div>;

export default Title;



// WEBPACK FOOTER //
// ./app/components/Title/index.js